import { apiClientV2 } from '@/services/rest-api/apiClient'
let baseURL = process.env.VUE_APP_REST_API_VSMS
baseURL = baseURL[baseURL.length] === '/' ? baseURL.slice(0, -1) : baseURL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/box-type',
    params: params,
  })

  return response?.data
}
